import { Typography } from "@mui/material";
import React from "react";
import Logo from "../assets/images/icons/pm-logo.svg";
import { injectIntl } from "react-intl";
function Footer(props) {
  const {intl} = props
  return (
    <div>
      <footer>
        <div className="footer-logo">
          <Typography color="primary" variant="subtitle1">{intl.formatMessage({id:"FOOTER.POWERED_BY"})}</Typography>
          <img src={Logo} alt="Property Monitor" />
        </div>
      </footer>
    </div>
  );
}

export default injectIntl(Footer);
